export enum ProductSubscriptionStripeStatus {
  NOT_APPLICABLE = 'not_applicable',
  ACTIVE = 'active',
  TRIALING = 'trialing',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  CANCELED = 'canceled',
  UNPAID = 'unpaid',
  PAST_DUE = 'past_due',
}

export enum ProductSubscriptionStripeItemStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  OFFBOARDING = 'OFFBOARDING',
  REMOVED = 'REMOVED',
}
